import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, InputGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Componente para mostrar y editar información básica del lead
 */
const LeadBasicInfo = ({ 
    detallesLead,
    editarNombreLead,
    setEditarNombreLead,
    editarGiroComercial,
    setEditarGiroComercial,
    editarCorreo,
    setEditarCorreo,
    actualizarNombreLead,
    actualizarGiroComercial,
    actualizarCorreo,
    cargandoModal,
    Modal_NombreLead,
    setModal_NombreLead,
    Modal_GiroComercial,
    setModal_GiroComercial,
    Modal_Correo,
    setModal_Correo
}) => {
    return (
        <Col md={7} xs={12}>
            {/* Nombre del Lead */}
            {editarNombreLead ? (
                <InputGroup className="fs--1">
                    <img width="25" src="/img/cliente48.png" alt="Cliente" />&nbsp;
                    <Form.Control
                        type="text"
                        size="sm"
                        defaultValue={Modal_NombreLead}
                        disabled={cargandoModal}
                        autoComplete="off"
                        onChange={(event) => setModal_NombreLead(event.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                actualizarNombreLead(Modal_NombreLead);
                            }
                        }}
                    />
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => actualizarNombreLead(Modal_NombreLead)}
                    >
                        <img src="/img/check25.png" width="20" alt="Confirmar" />
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setEditarNombreLead(false)}
                    >
                        ✕
                    </Button>
                </InputGroup>
            ) : cargandoModal ? (
                <div className="d-flex align-items-center gap-2 mb-2">
                    <Skeleton width={25} height={25} />
                    <Skeleton width={200} height={32} />
                </div>
            ) : (
                <>
                    <img width="25" src="/img/cliente48.png" alt="Cliente" />&nbsp;
                    <strong className="fs-2">{detallesLead.vNombreLead} </strong>
                    <OverlayTrigger 
                        placement="top"
                        overlay={<Tooltip id="tooltip">Editar Nombre Lead</Tooltip>}
                    >
                        <span>
                            &nbsp;<img 
                                style={{ cursor: 'pointer' }} 
                                width={20} 
                                src="/img/editar20.png" 
                                onClick={() => setEditarNombreLead(true)}
                                alt="Editar"
                            />
                        </span>
                    </OverlayTrigger>
                </>
            )}

            {/* WhatsApp */}
            <br />
            {cargandoModal ? (
                <div className="d-flex align-items-center gap-2 mb-2">
                    <Skeleton width={20} height={20} />
                    <Skeleton width={30} height={30} />
                    <Skeleton width={150} height={24} />
                </div>
            ) : (
                detallesLead.vTelefonoLead != undefined && (
                    <>
                        {detallesLead.vTelefonoLead.includes('+52') && (
                            <img title="México" src="/img/bandera-mexico-48.png" width="20" alt="Bandera de México" />
                        )}
                        <a className="text-900 fs-2" href={`https://wa.me/${detallesLead.vTelefonoLead}`} target="_blank" rel="noreferrer">
                            <img width="30" src="/img/whatsapp40.png" alt="Icono de WhatsApp" />
                            {detallesLead.vTelefonoLead}
                        </a>
                    </>
                )
            )}

            {/* Giro comercial */}
            <br />
            {editarGiroComercial ? (
                <InputGroup className="fs--1">
                    <img width="30" src="/img/sucursal20.png" alt="Sucursal" />&nbsp;
                    <Form.Control
                        type="text"
                        size="sm"
                        defaultValue={Modal_GiroComercial}
                        disabled={cargandoModal}
                        autoComplete="off"
                        onChange={(event) => setModal_GiroComercial(event.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                actualizarGiroComercial(Modal_GiroComercial);
                            }
                        }}
                    />
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => actualizarGiroComercial(Modal_GiroComercial)}
                    >
                        <img src="/img/check25.png" width="20" alt="Confirmar" />
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setEditarGiroComercial(false)}
                    >
                        ✕
                    </Button>
                </InputGroup>
            ) : cargandoModal ? (
                <div className="d-flex align-items-center gap-2 mb-2">
                    <Skeleton width={25} height={25} />
                    <Skeleton width={180} height={24} />
                </div>
            ) : (
                <>
                    <img width="25" src="/img/sucursal20.png" alt="Sucursal" />&nbsp;
                    <span className="fs-2">{detallesLead.vGiroComercial}</span>
                    <OverlayTrigger 
                        placement="top"
                        overlay={<Tooltip id="tooltip">Editar Giro Comercial</Tooltip>}
                    >
                        <span>
                            &nbsp;<img 
                                style={{ cursor: 'pointer' }} 
                                width={20} 
                                src="/img/editar20.png" 
                                onClick={() => setEditarGiroComercial(true)}
                                alt="Editar"
                            />
                        </span>
                    </OverlayTrigger>
                </>
            )}

            {/* Correo electrónico */}
            <br />
            {editarCorreo ? (
                <InputGroup className="fs--1">
                    <img width="30" src="/img/correo48.png" alt="Correo" />&nbsp;
                    <Form.Control
                        type="text"
                        size="sm"
                        defaultValue={Modal_Correo}
                        disabled={cargandoModal}
                        autoComplete="off"
                        onChange={(event) => setModal_Correo(event.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                actualizarCorreo(Modal_Correo);
                            }
                        }}
                    />
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => actualizarCorreo(Modal_Correo)}
                    >
                        <img src="/img/check25.png" width="25" alt="Confirmar" />
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setEditarCorreo(false)}
                    >
                        ✕
                    </Button>
                </InputGroup>
            ) : cargandoModal ? (
                <div className="d-flex align-items-center gap-2 mb-2">
                    <Skeleton width={25} height={25} />
                    <Skeleton width={200} height={24} />
                </div>
            ) : (
                <>
                    <img width="25" src="/img/correo48.png" alt="Correo" />&nbsp;
                    <span className="fs-2">{detallesLead.vCorreo}</span>
                    <OverlayTrigger 
                        placement="top"
                        overlay={<Tooltip id="tooltip">Editar Correo</Tooltip>}
                    >
                        <span>
                            &nbsp;<img 
                                style={{ cursor: 'pointer' }} 
                                width={20} 
                                src="/img/editar20.png" 
                                onClick={() => setEditarCorreo(true)}
                                alt="Editar"
                            />
                        </span>
                    </OverlayTrigger>
                </>
            )}
        </Col>
    );
};

LeadBasicInfo.propTypes = {
    detallesLead: PropTypes.shape({
        idLead: PropTypes.number,
        vNombreLead: PropTypes.string,
        vGiroComercial: PropTypes.string,
        vCorreo: PropTypes.string,
        vTelefonoLead: PropTypes.string
    }).isRequired,
    editarNombreLead: PropTypes.bool.isRequired,
    setEditarNombreLead: PropTypes.func.isRequired,
    editarGiroComercial: PropTypes.bool.isRequired,
    setEditarGiroComercial: PropTypes.func.isRequired,
    editarCorreo: PropTypes.bool.isRequired,
    setEditarCorreo: PropTypes.func.isRequired,
    actualizarNombreLead: PropTypes.func.isRequired,
    actualizarGiroComercial: PropTypes.func.isRequired,
    actualizarCorreo: PropTypes.func.isRequired,
    cargandoModal: PropTypes.bool.isRequired,
    Modal_NombreLead: PropTypes.string.isRequired,
    setModal_NombreLead: PropTypes.func.isRequired,
    Modal_GiroComercial: PropTypes.string.isRequired,
    setModal_GiroComercial: PropTypes.func.isRequired,
    Modal_Correo: PropTypes.string.isRequired,
    setModal_Correo: PropTypes.func.isRequired
};

export default LeadBasicInfo;
